import React from 'react';
import Modal from 'react-responsive-modal';
import _ from 'lodash';
import ReactTable from "react-table";
import Translate from 'translate';
import moment from 'moment';
import { injectIntl } from "react-intl";
import { connect } from "react-redux";

class BillModal extends React.Component {
  constructor( props ) {
    super( props );
  }

  render() {
    const { data, onClose, open, dateFormat } = this.props;

    return (
      <Modal little
             modalClassName="col-md-8 max-width-unset client-folder p-0"
             open={open}
             onClose={onClose}>

        <div className="p-3 mb-4 bg-blue">
          <h5 className="m-0 d-inline-block"><Translate id="bill"/> {_.get( data, 'DocNumber' )}</h5>
        </div>

        <div className="px-3">
          <div className="row">
            <div className="col-md-4">
              <p className="mb-1"><Translate id="cycle"/>: {_.get( data, 'BillCycle', '-' )}</p>
              <p className="mb-1"><Translate id="type"/>: {_.get( data, 'BillType', '-' )}</p>
              <p className="m-0"><Translate
                id="period"/>: { moment.unix( _.get( data, 'BillFromDate', '' ) ).format( dateFormat )   } - {moment.unix( _.get( data, 'BillToDate', '-' ) ).format( dateFormat ) }</p>
            </div>
            <div className="col-md">
              <p className="mb-1"><Translate id="pendingAmount"/>: {_.get( data, 'PendingAmount', '-' )}</p>
              <p className="m-0"><Translate id="status"/>: {_.get( data, 'BillStatus', '-' )}</p>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-md-12">
              <h6><Translate id="historic"/></h6>
              <ReactTable className="app-table -highlight app-table-white"
                          data={_.get( data, 'HistoricalStatus' )}
                          pageSize={_.get( data, 'HistoricalStatus' ) ? data.HistoricalStatus.length : 0}
                          resizable={false}
                          sortable={false}
                          showPaginationBottom={false}
                          showPaginationTop={false}
                          columns={[
                            { Header: 'Status', accessor: 'Status' },
                            { 
                              Header: 'Date', 
                              accessor: 'StatusDate',
                              Cell: props => props.value ? moment.unix( props.value ).format( dateFormat ) : ''
                            },
                          ]}
              />
            </div>
          </div>

          {_.get( data, 'DocLink' ) ?
            <div className="row mb-3">
              <div className="col-md-12 text-right">
                <a className="color-link p-3 text-uppercase" target="_blank" href={_.get( data, 'DocLink' )}>
                  <Translate id="download"/>
                </a>
              </div>
            </div> : null}
        </div>
      </Modal>
    )
  }
}
const mapStateToProps = ( state, ownProps ) => ( {
  locale: state.settings.locale,
  dateFormat: state.settings.dateFormat,
} );
export default injectIntl( connect( mapStateToProps )( BillModal ) );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/ClientFolder/BillModal/index.js